var render = function render(){var _vm=this,_c=_vm._self._c;return _c('convenio-import')
}
var staticRenderFns = []

export { render, staticRenderFns }